import { BulkResource } from "../types";
import {
  useMutationCreateBulkCalculate1099Batch,
  useMutationUpdateBulkCalculate1099Batch
} from "./bulkCalculation1099/mutations";
import {
  useBulkCalculate1099Batch,
  useBulkCalculate1099BatchSummary
} from "./bulkCalculation1099/queries";
import {
  useMutationCreateBulkCollaboratorBatch,
  useMutationDeleteBulkCollaboratorBatch,
  useMutationUpdateBulkCollaboratorBatch
} from "./bulkCollaborator/mutations";
import {
  useAllBulkCollaboratorBatchItems,
  useBulkCollaboratorBatch,
  useBulkCollaboratorBatchSummary,
  useBulkCollaboratorImportingBatch
} from "./bulkCollaborator/queries";
import {
  useMutationCreateBulkPayableBatch,
  useMutationDeleteBulkPayableBatch,
  useMutationUpdateBulkPayableBatch
} from "./bulkPayable/mutations";
import {
  useAllBulkPayableBatchItems,
  useBulkPayableBatch,
  useBulkPayableBatchSummary,
  useBulkPayableImportingBatch
} from "./bulkPayable/queries";

const bulkBatchQueryMap = {
  [BulkResource.Payable]: {
    useBulkBatch: useBulkPayableBatch,
    useBulkBatchImporting: useBulkPayableImportingBatch,
    useCreateBulkBatch: useMutationCreateBulkPayableBatch,
    useBulkBatchSummary: useBulkPayableBatchSummary,
    useUpdateBulkBatch: useMutationUpdateBulkPayableBatch,
    useDeleteBulkBatch: useMutationDeleteBulkPayableBatch,
    useAllBulkBatchItems: useAllBulkPayableBatchItems
  },
  [BulkResource.Collaborator]: {
    useBulkBatch: useBulkCollaboratorBatch,
    useBulkBatchImporting: useBulkCollaboratorImportingBatch,
    useCreateBulkBatch: useMutationCreateBulkCollaboratorBatch,
    useBulkBatchSummary: useBulkCollaboratorBatchSummary,
    useUpdateBulkBatch: useMutationUpdateBulkCollaboratorBatch,
    useDeleteBulkBatch: useMutationDeleteBulkCollaboratorBatch,
    useAllBulkBatchItems: useAllBulkCollaboratorBatchItems
  },
  [BulkResource.Calculate1099]: {
    useBulkBatch: useBulkCalculate1099Batch,
    useBulkBatchImporting: useBulkCalculate1099Batch,
    useCreateBulkBatch: useMutationCreateBulkCalculate1099Batch,
    useBulkBatchSummary: useBulkCalculate1099BatchSummary,
    useUpdateBulkBatch: useMutationUpdateBulkCalculate1099Batch,
    useDeleteBulkBatch: () => {
      throw new Error("Bulk Calculate 1099 delete not implemented");
    },
    useAllBulkBatchItems: () => {
      throw new Error("Bulk Calculate 1099 all batch items not implemented");
    }
  }
};

export function getBulkQueriesByResource(bulkResource: BulkResource) {
  return bulkBatchQueryMap[bulkResource];
}
